import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {Scanner3dAccountModel} from '../../../api/entity/scanner3dAccount.model';

@Injectable()
export class Scanner3dAccountRepository extends AbstractRepositoryV2<Scanner3dAccountModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Scanner3dAccount', serviceElementsFactory, injector);
    }
}
